import { useState } from "react";
import { Helmet } from "react-helmet-async";

const PHOTOS = [
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/home-page-brown-bear-Matt.jpg", cat: "alaska", caption: "Alaska — Brown Bear" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/Alaskan-fall-brown-bear-hunt.jpg", cat: "alaska", caption: "Alaska — Fall Brown Bear" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/brown-bear-hunt-Alaska.jpg", cat: "alaska", caption: "Alaska — Spring Brown Bear" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/Brown-Bear-Spring-Alaska1.jpg", cat: "alaska", caption: "Alaska — Brown Bear Spring" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/Brown-Bear-Alaska-3-1.jpg", cat: "alaska", caption: "Alaska — Bear Camp" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/09/IMG_1646.jpeg", cat: "alaska", caption: "Alaska — Grizzly Spring" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/1-guided-Moose-bear-combo.jpg", cat: "alaska", caption: "Alaska — Moose & Bear Combo" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/Moose-photo-guided-1.jpg", cat: "alaska", caption: "Alaska — Guided Moose" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/Moose-Fall-Alaska-4.jpg", cat: "alaska", caption: "Alaska — Fall Moose" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/unguided-Alaskan-Moose-hunts.jpg", cat: "alaska", caption: "Alaska — Yukon Moose" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/montana-elk-rifle-hunt.jpg", cat: "montana", caption: "Montana — Elk Rifle Hunt" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/Elk-Hunt-Montana-3.jpg", cat: "montana", caption: "Montana — Elk" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/Mule-Deer-Wyoming.jpeg", cat: "montana", caption: "Wyoming — Mule Deer" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/02/Spring-Black-Bear.jpg", cat: "montana", caption: "Montana — Spring Black Bear" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/Tajikistan-Marco-Polo.jpg", cat: "asia", caption: "Tajikistan — Marco Polo Sheep" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2026/01/IMG_3693.jpeg", cat: "asia", caption: "Central Asia — Marco Polo" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/03/daea59cd-fc62-4190-96d0-6074bf323700.jpeg", cat: "asia", caption: "Mongolia — Argali" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2024/12/Brown-Bear-Kamchatka.jpg", cat: "international", caption: "Kamchatka — Brown Bear" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/03/2b3bd60b-3821-40e2-b178-75f16c50775e.jpeg", cat: "africa", caption: "South Africa — Safari" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/10/IMG_2826.jpeg", cat: "international", caption: "Pakistan — Himalayan Ibex" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/10/IMG_2823.jpeg", cat: "international", caption: "Pakistan — Blandford Urial" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/10/IMG_2821.jpeg", cat: "international", caption: "Pakistan — Blue Sheep" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/10/IMG_2831.jpeg", cat: "international", caption: "Australia — Water Buffalo" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/10/IMG_2828.jpeg", cat: "international", caption: "Australia — Banteng" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/03/IMG_0805-1.jpeg", cat: "international", caption: "Canada — Polar Bear" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/03/IMG_5664-1-scaled.jpeg", cat: "international", caption: "Canada — Musk Ox" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/03/IMG_7521.jpeg", cat: "international", caption: "British Columbia — Mountain Goat" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/03/IMG_5676-scaled.jpeg", cat: "international", caption: "Mexico — Mule Deer" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/10/IMG_2815.jpeg", cat: "international", caption: "Mauritius — Rusa Deer" },
  { src: "https://dispatchhunts.com/wp-content/uploads/2025/09/WhatsApp-Image-2025-09-16-at-12.50.01-PM.jpeg", cat: "international", caption: "Pakistan — Sindh Ibex" },
];

const FILTERS = [
  { value: "all", label: "All" },
  { value: "alaska", label: "Alaska" },
  { value: "montana", label: "Montana & West" },
  { value: "africa", label: "Africa" },
  { value: "asia", label: "Central Asia" },
  { value: "international", label: "International" },
];

export default function Gallery() {
  const [filter, setFilter] = useState("all");
  const filtered = filter === "all" ? PHOTOS : PHOTOS.filter((p) => p.cat === filter);

  return (
    <>
      <Helmet>
        <title>Gallery | Dispatch Hunts</title>
        <meta name="description" content="Real hunts. Real moments. Photos from the field across six continents." />
      </Helmet>

      {/* Hero */}
      <section className="section-dark grain pt-28 pb-12" data-testid="gallery-hero">
        <div className="container-dh text-center">
          <p className="text-label text-brass mb-4">From the Field</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-bone mb-4" data-testid="gallery-headline">
            Real hunts. Real moments.
          </h1>
          <p className="font-body text-bone/50 max-w-lg mx-auto">
            Every photo here is from a hunt we coordinated. No stock images. No staged shots. Just the real thing.
          </p>
        </div>
      </section>

      {/* Filters + Grid */}
      <section className="section-chalk py-12 lg:py-16" data-testid="gallery-grid">
        <div className="container-dh">
          <div className="flex flex-wrap gap-2 mb-10 justify-center" data-testid="gallery-filters">
            {FILTERS.map((f) => (
              <button key={f.value} onClick={() => setFilter(f.value)}
                className={`px-5 py-2.5 text-sm font-label font-semibold tracking-wider uppercase transition-all border
                  ${filter === f.value ? "bg-brass text-bone border-brass" : "bg-bone border-carbon/10 text-carbon hover:border-brass/40"}`}
                data-testid={`gallery-filter-${f.value}`}
              >{f.label}</button>
            ))}
          </div>
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-3 space-y-3">
            {filtered.map((p, i) => (
              <div key={p.src} className="break-inside-avoid group relative overflow-hidden" data-testid={`gallery-photo-${i}`}>
                <img src={p.src} alt={p.caption} className="w-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-carbon/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <p className="absolute bottom-3 left-3 right-3 text-label text-bone text-[10px] opacity-0 group-hover:opacity-100 transition-opacity">
                  {p.caption}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
